export function imageQueueLabel(queue) {
  if (!queue) return 'Aguardando atualização da fila';
  const position=queue.queue_position && queue.queue_total ? queue.queue_position+'/'+queue.queue_total+' na fila geral' : '';
  const state=queue.phase==='waiting_rate_limit' ? 'Aguardando limite de chamadas'
    : queue.phase==='generating' ? 'Gerando imagem agora'
    : queue.phase==='preparing' ? 'Preparando geração' : 'Aguardando sua vez';
  return [position,state].filter(Boolean).join(' · ');
}
export function imageQueueWait(queue) {
  if(queue?.phase!=='waiting_rate_limit' || !queue.retry_at)return '';
  const seconds=Math.max(0,Math.ceil((queue.retry_at-Date.now())/1000));
  return seconds>0 ? 'Nova tentativa em cerca de '+seconds+' segundos.' : 'Retomando a geração…';
}
